import React, { useState } from 'react';
import { useSticky } from '@hooks';
import Grid from '@components/Grid';
import HeaderWrapper from '../HeaderWrapper';
import { Logo, Assistance } from './components';

import B2BHeaderNav from './B2BHeaderNav';
import B2BHeaderNavContainer from './B2BHeaderNavContainer';

const B2BHeader = () => {
  const [isSticky] = useSticky();
  const [isMenuItemsOpened, setMenuItemsOpened] = useState(false);
  return (
    <B2BHeaderNavContainer
      isSticky={isSticky}
      isMenuItemsOpened={isMenuItemsOpened}
    >
      <B2BHeaderNav>
        <Grid isB2B isHeaderSticky={isSticky} isMenuOpened={isMenuItemsOpened}>
          {gridStyles => (
            <>
              <HeaderWrapper
                classNames={{
                  menu: gridStyles.menu,
                  product: gridStyles.product,
                  promo: gridStyles.promo,
                  search: gridStyles.search,
                  contact: gridStyles.contact,
                  account: gridStyles.account,
                  list: gridStyles.list,
                  basket: gridStyles.basket,
                  dropdown: gridStyles.menuDropdown,
                  mobileBasket: gridStyles.mobileBasket,
                  mobileAccount: gridStyles.mobileAccount,
                  mobileMenu: gridStyles.mobileMenu,
                  mobileList: gridStyles.mobileList,
                  familiesContainer: gridStyles.familiesContainer,
                }}
                isSticky={isSticky}
                isMenuItemsOpened={isMenuItemsOpened}
                onMenuOpened={setMenuItemsOpened}
              >
                <Logo isB2B className={gridStyles.B2Blogo} />
                <Assistance />
              </HeaderWrapper>
            </>
          )}
        </Grid>
      </B2BHeaderNav>
    </B2BHeaderNavContainer>
  );
};

B2BHeader.displayName = 'B2BHeader';

export default B2BHeader;
